var React = require('react');

function IconArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.2071 7.29289C15.8166 6.90237 15.1834 6.90237 14.7929 7.29289C14.4024 7.68342 14.4024 8.31658 14.7929 8.70711L17.0858 11L5.5 11C4.94772 11 4.5 11.4477 4.5 12C4.5 12.5523 4.94772 13 5.5 13L17.0858 13L14.7929 15.2929C14.4024 15.6834 14.4024 16.3166 14.7929 16.7071C15.1834 17.0976 15.8166 17.0976 16.2071 16.7071L20.2071 12.7071C20.3946 12.5196 20.5 12.2652 20.5 12C20.5 11.7348 20.3946 11.4804 20.2071 11.2929L16.2071 7.29289Z","fill":"white"}));
}

IconArrow.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = IconArrow;

IconArrow.default = IconArrow;
